<app-maintenance-mode-alert></app-maintenance-mode-alert>
<app-location-context-panel></app-location-context-panel>

<div class="content" *ngIf="showFlights">
    <mat-card>
        <mat-card-content>
            <h1>AODB Flight Plan</h1>
            <div class="flight-items">
                <div class="flight-item" 
                    *ngFor="let flight of flights; last as isLast" 
                    [ngClass]="{'greyed-out': isGreyedOut(flight)}">
                    <div class="block icon">
                        <mat-icon svgIcon="{{ getFlightTypeIconName(flight) }}"></mat-icon>
                    </div>
                    <div class="block fields">
                        <div class="field centerline">
                            <span class="label">Centerline</span>
                            <span class="value">{{ flight?.stand }}</span>
                        </div>
                        <div class="field acType">
                            <span class="label">AC Type</span>
                            <span class="value">{{ flight?.acType }}</span>
                        </div>
                        <div class="field flight">
                            <span class="label">Flight Number</span>
                            <span class="value">{{ flight?.flightNumber }}</span>
                        </div>
                    </div>
                    <div class="block time">
                        <app-time-counter [timeString]='flight?.time?.timeString' [timeType]='flight?.time?.timeType'></app-time-counter>
                    </div>
                </div>
            </div>
            <div class="no-data" *ngIf="flights?.length === 0">
                No data found
            </div>
        </mat-card-content>
    </mat-card>
</div>